import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorSate = () => {
  const { t } = useTranslation('app');

  return (
    <div className="rounded-[16px] border border-gray bg-white px-2x py-4x text-center text-body-1 text-red_dark">
      {t('somethingWrong')}
    </div>
  );
};

export default ErrorSate;
